import { Component, Inject, OnInit, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GlobalConstants } from 'src/app/app.component';
import { APIService } from 'src/app/common/api.component';
import { Constants } from 'src/app/common/constants';
import { ErrorData } from 'src/app/common/ErrorData';

@Component({
  selector: 'siteres-dialog',
  templateUrl: './siteres-dialog.component.html'
})
export class SiteResDialogComponent implements OnInit {
  siteData: any = null;
  myWindow: any
  errorDetails: ErrorData;
  errorMsg: string;
  isRestrictedSite: boolean = false;
  isRefreshReq: boolean = false;
  continue = Constants.CONTINUE
  ok = Constants.OK
  alert = Constants.ERROR
  continueCancelDesc = Constants.CONTINUE_CANCEL_DESC
  siteNameDesc = Constants.SITENAME_DESC
  restrictedSite = Constants.RESTRICTED_SITES
  cancelLabel = Constants.CANCEL
  arr = [];
  loading: boolean = false
  isNovisible=false;
  isFullScreen = false
  constructor(
    private apiService: APIService,
    private dialogRef: MatDialogRef<SiteResDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.errorDetails = data.errorData;
    
    
    if (this.errorDetails.errorCode == Constants.LOGGED_OUT) {
      this.dialogRef.close();
    }else if (this.errorDetails.errorCode == Constants.UNSUPPORTED_FILE_FOLDER) {
      this.alert=Constants.UNSUPPORTED_VIEW_TITLE;
      this.ok='Yes';
      this.isNovisible=true;
    }else if(this.errorDetails.errorCode == Constants.SURE_LOGOUT_CODE){
      this.alert=Constants.LOGOUT_TITLE;
      this.ok='Yes';
      this.isNovisible=true;
    }
    this.siteData = data.errorData.sites;
    this.isFullScreen = data.errorData.isFullScreen
    this.errorMsg = this.errorDetails.errorMsg
    if (this.errorMsg == undefined || this.errorMsg == null || this.errorMsg.length == 0) {
      this.errorMsg = Constants.COMMON_ERR_MSG
    }
    var refNo: number = this.errorDetails.refCode
    if (this.siteData != null && this.siteData != undefined) {
      GlobalConstants.siteFolderId = +this.siteData.sitefolderID;
      GlobalConstants.siteName = this.siteData.sitename;
      if (this.siteData.siteRestrictionType.passwordprotected == 1) {
        this.arr.push(Constants.PASSWORD_PROTECTED)
      }
      if (this.siteData.siteRestrictionType.twoFactorAuthentication == 1) {
        this.arr.push(Constants.TWO_FACTOR_AUTH)
      }
      if (this.siteData.siteRestrictionType.termsandconditions == 1) {
        this.arr.push(Constants.TERMS_AND_CONDITIONS)
      }
    }

    if (refNo == 432 || refNo == 433 || refNo == 434) {
      this.isRestrictedSite = true;
    }
  }

  ngOnInit() {
    this.apiService.fatchTeamsId();
    this.apiService.setTheme();
  }

  cancel() {
    this.dialogRef.close(false);
  }

  save() {
   // this.isRestrictedSite = false;
    this.isRefreshReq = true;
    this.ok = Constants.REFRESH
    this.alert = Constants.ALERT
    this.errorMsg = Constants.REFRESH_SITE_RES_MSG
    this.myWindow = window.open(JSON.parse(this.errorDetails.errorJson)['link'], '_blank');
  }

  close() {
    if (this.isRefreshReq) {
      this.callFolderInfo()
    } else
      if (this.errorDetails.errorCode != 429)
        this.dialogRef.close(this.errorDetails);
  }



  callFolderInfo() {
    this.loading = true
    this.apiService.getFolderInfo(this.errorDetails.apiData.parentFolderId).subscribe(data => {
      this.loading = false
      this.dialogRef.close(true);
    }, err => {
      this.loading = false
      this.dialogRef.close(err.errorMsg);
    })
  }
}
